import { privateClient, privateTvClient, publicClient } from "./client";

const fetchFeature = featureName => privateClient.get(`/v1/features/${featureName}/enabled`);

const fetchTvFeature = featureName => privateTvClient.get(`/v1/features/${featureName}/enabled`);

const fetchPublicFeature = () => publicClient.get(`/v1/features/public`);

export { fetchFeature, fetchTvFeature, fetchPublicFeature };
